import React, { useState } from "react";
// Eliminamos imports manuales de botones y lógica de ESC
import DrawerFilter from "../../../components/listing/DrawerFilter";

export default function FiltroImpuesto({
  initialFilters = {},
  onSubmit = () => {},
  onClose = () => {},
}) {
  // --- ESTADOS DE FILTROS ---
  const [numero, setNumero] = useState(initialFilters.numero || "");
  const [data, setData] = useState(initialFilters.data || "");
  const [dataFechaini, setDataFechaini] = useState(initialFilters.dataFechaini || "");
  const [dataFechafin, setDataFechafin] = useState(initialFilters.dataFechafin || "");
  
  const [isLoading, setIsLoading] = useState(false);

  // --- SUBMIT ---
  const handleApply = () => {
    setIsLoading(true);
    
    onSubmit({
      numero: numero.trim(),
      data: data,           
      dataFechaini: dataFechaini,
      dataFechafin: dataFechafin,
      // dataIngreso se mantiene excluido como en el original
    });

    setIsLoading(false);
    onClose();
  };

  return (
    <DrawerFilter
      title="Filtros de Certificados"
      onClose={onClose}
      onApply={handleApply}
      isLoading={isLoading}
    >
      {/* 1. Nro. Certificado */}
      <div>
        <label className="form-label-fil">Nro. de Certificado:</label>
        <input 
          type="text" 
          className="input mt-1 w-full" 
          value={numero} 
          onChange={(e) => setNumero(e.target.value)} 
          placeholder="Ej: CERT-2025..."
        />
      </div>

      {/* 2. Fecha del Certificado */}
      <div>
        <label className="form-label-fil">Fecha del Certificado:</label>
        <input 
          type="date" 
          className="input mt-1 w-full" 
          value={data} 
          onChange={(e) => setData(e.target.value)} 
        />
      </div>

      {/* Separador Visual (Mantenido del original) */}
      <div className="border-t border-gray-200 my-2"></div>
      
      {/* 3. Fecha de inicio del Certificado */}
      <div>
        <label className="form-label-fil">Fecha de inicio del Certificado:</label>
        <input 
          type="date" 
          className="input mt-1 w-full" 
          value={dataFechaini} 
          onChange={(e) => setDataFechaini(e.target.value)} 
        />
      </div>

      {/* 4. Fecha de fin del Certif. */}
      <div>
        <label className="form-label-fil">Fecha de fin del Certif.:</label>
        <input 
          type="date" 
          className="input mt-1 w-full" 
          value={dataFechafin} 
          onChange={(e) => setDataFechafin(e.target.value)} 
        />
      </div>

    </DrawerFilter>
  );
}